import React from 'react';
import { plantData } from '../plantData';
import './Greenhouse.css';

const Greenhouse = ({ completedPlants = [], onBack }) => {
    const allPlants = Object.keys(plantData);

    return (
        <div className="greenhouse-container">
            <div className="greenhouse-header">
                <h2>Our Greenhouse</h2>
                <button onClick={onBack} className="back-button">← Back to Garden</button>
            </div>
            <div className="greenhouse-grid">
                {allPlants.map(plantKey => {
                    const isCompleted = completedPlants.includes(plantKey);
                    const plant = plantData[plantKey];
                    const displayImage = isCompleted ? plant.images[plant.images.length - 1] : '/images/plants/placeholder.png'; // You need a placeholder image

                    return (
                        <div key={plantKey} className={`greenhouse-slot ${isCompleted ? 'completed' : ''}`}>
                            <img src={displayImage} alt={plant.name} />
                            <p>{isCompleted ? plant.name : '???'}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Greenhouse;
